import api from '../api/axios';

export interface JournalLine {
  id?: number;
  journalEntry?: number;
  account: number;
  debit?: number;
  credit?: number;
  description?: string;
  lineNumber?: number;
}

export interface JournalEntry {
  id?: number;
  entryNumber: string;
  date: string;
  description: string;
  status?: 'draft' | 'posted' | 'void';
  createdBy: number;
  postedBy?: number;
  postedDate?: string;
  reference?: string;
  totalDebit?: number;
  totalCredit?: number;
}

const JournalEntryService = {
  getAll: (params?: any) => api.get('/journal-entries', { params }),
  getOne: (id: number, params?: any) => 
    api.get(`/journal-entries/${id}`, { 
      params: params || { populate: ['createdBy', 'postedBy'] } 
    }),
  create: (data: JournalEntry) => api.post('/journal-entries', { data }),
  update: (id: number, data: Partial<JournalEntry>) => 
    api.put(`/journal-entries/${id}`, { data }),
  delete: (id: number) => api.delete(`/journal-entries/${id}`),
  
  // Journal Lines
  getLines: (journalEntryId: number) =>
    api.get('/journal-lines', {
      params: {
        'filters[journalEntry][id][$eq]': journalEntryId,
        populate: 'account',
        sort: 'lineNumber:asc',
      },
    }),
  createLine: (data: JournalLine) => api.post('/journal-lines', { data }),
  updateLine: (id: number, data: Partial<JournalLine>) =>
    api.put(`/journal-lines/${id}`, { data }),
  deleteLine: (id: number) => api.delete(`/journal-lines/${id}`),
  
  // Post journal entry
  post: (id: number, postedBy: number) =>
    api.put(`/journal-entries/${id}`, {
      data: {
        status: 'posted',
        postedBy,
        postedDate: new Date().toISOString(),
      },
    }),
};

export default JournalEntryService;

